var __webpack_exports__ = {};
/*!**************************************!*\
  !*** ./src/js/complement-product.js ***!
  \**************************************/
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var checkedRadio = document.querySelector('.product-radio__input .radio:checked');
var cardWrappers = document.querySelectorAll(".card-wrapper.complement-card-wrapper");
if (document.querySelector('.quick-add-modal')) {
  observeDOM();
}
document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector('.complement-products-wrapper')) {
    getComplementInfo();
  }
});
function getComplementInfo() {
  var complementContainer = document.querySelector('.complement-products-wrapper');
  var complementCard = complementContainer.querySelectorAll('.card-wrapper');
  var isRadiocard = false;
  complementCard.forEach(function (card) {
    isRadiocard = false;
    if (card.classList.contains('massage') || card.classList.contains('soin') || card.classList.contains('Expérience thermale') || card.classList.contains('Abonnement') || card.classList.contains('Forfait')) {
      isRadiocard = true;
    }
    if (isRadiocard === true) {
      getComplementRadioSelected(card);
    }
  });
}
function getComplementRadioSelected(card) {
  var radioInputs = card.querySelectorAll('.product-radio__input .radio');
  checkedRadio = card.querySelector('.product-radio__input .radio:checked');
  radioInputs.forEach(function (input) {
    input.onclick = function (e) {
      checkedRadio = e.target.dataset.variantId;
      changeFormData(card, checkedRadio);
    };
  });
}
function changeFormData(card, id) {
  var formId = card.querySelector('input[name="id"]');
  var formProductId = card.querySelector('input[name="product-id"]');
  formId.value = id;
  formProductId.value = id;
}
function observeDOM() {
  var targetNode = document.body;
  var config = {
    childList: true,
    subtree: true
  };
  var callback = function callback(mutationsList, observer) {
    var _iterator = _createForOfIteratorHelper(mutationsList),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var mutation = _step.value;
        if (mutation.type === 'childList') {
          var wrapper = document.querySelectorAll('.complement-products-wrapper');
          if (wrapper.length > 0) {
            getComplementInfo();
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
  var observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}
function toggleDescription(element) {
  var content = element.nextElementSibling;
  var caret = element.querySelector('.caret');
  if (content.style.maxHeight) {
    content.style.maxHeight = null;
    caret.classList.remove('open');
  } else {
    content.style.maxHeight = content.scrollHeight + "px";
    caret.classList.add('open');
  }
}
